import { format } from 'date-fns';

export const formatDateForBraze = (d?: any) => {
  const date = typeof d === 'undefined' ? new Date() : new Date(d);
  return format(date, 'Y-MM-dd kk:mm:ss');
};
